/* eslint-disable no-unused-vars */
/*Configuration Import */
import apiService from './apiservice';

/*Library Definition */
const validateApi={
    /*Load Data user method */
    /* TODO: cb */
    /* Revisit to Reload Data */
    /*loadData:(memberId,setIsLoading)=>{
        return apiService.get("validateload/"+memberId,{headers:{Authorization:"Token " + window.config.token}}).catch((error) => {
            setIsLoading(prevState=>true);
            notify({message:"Oops! Something went wrong, please contact the administrator of the website",position:"top center"}, "error", window.config.toastTime);
            console.log(error);
        });
    },*/


    /*edit email method */
    editEmail:(memberId,payLoad,setIsLoading)=>{
        return apiService.get("onboard/edit/email?email="+payLoad.email+"&userId="+memberId,{headers:{Authorization:"Token " + window.config.token}}).catch((error) => {
            setIsLoading(prevState=>false);
            console.log(error);
        });
    },
    /*edit phone method */
    editPhone:(memberId,payLoad,setIsLoading)=>{
        return apiService.get("onboard/edit//phone?phone=%2b1"+payLoad.phone+"&userId="+memberId, {headers:{Authorization:"Token " + window.config.token}}).catch((error) => {
            setIsLoading(prevState=>false);
            console.log(error);
        });
    },
    /*resend email method */
    resendEmail:(memberId,payLoad,setIsLoading)=>{
        return apiService.get("verify/email?email="+payLoad.email, {headers:{Authorization:"Token " + window.config.token}}).catch((error) => {
            setIsLoading(prevState=>false);
            console.log(error);
        });
    },
    /*resend email method */
    resendPhone:(memberId,payLoad,setIsLoading)=>{
        return apiService.get("verify/phone?phone=%2b1"+payLoad.phone, {headers:{Authorization:"Token " + window.config.token}}).catch((error) => {
            setIsLoading(prevState=>false);
            console.log(error);
        });
    },
    /*validate code email method */
    validateCodeEmail:(memberId,payLoad,setIsLoading)=>{
        return apiService.get("/verify/code/email?email="+payLoad.email+"&code="+payLoad.code+"&userId="+memberId, {headers:{Authorization:"Token " + window.config.token}}).catch((error) => {
            setIsLoading(prevState=>false);
            console.log(error);
        });
    },
    /*validate code phone method */
    validateCodePhone:(memberId,payLoad,setIsLoading)=>{
        return apiService.get("/verify/code/phone?phone=%2b1"+payLoad.phone+"&code="+payLoad.code+"&userId="+memberId, {headers:{Authorization:"Token " + window.config.token}}).catch((error) => {
            setIsLoading(prevState=>false);
            console.log(error);
        });
    },
}

export default validateApi;